export default function getInitials(name: string = ''): string {
    if (!name) return '';
    const nameArray = name.split(' ').slice(0, 2);
    const initials = nameArray.map((word) => word.charAt(0).toUpperCase()).join('');
    return initials;
}
